// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-1e7fc502] .modal-body{padding:0;display:flex;flex-direction:column;background-color:#f9f9f7}[data-v-1e7fc502] .modal-header{background-color:#c73d3d;color:#fff}[data-v-1e7fc502] .modal-content{border:0;border-radius:0;background-color:#f9f9f7}[data-v-1e7fc502] .modal-dialog{max-width:100%;margin:0;top:0;bottom:0;left:0;right:0;height:100vh;display:flex}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
